 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"locale-en-US-json":"locale-en-US-json","locale-ru-RU-json":"locale-ru-RU-json"}[chunkId]||chunkId) + "." + {"chunk-2d0d7e47":"78563446","chunk-6ace265c":"d7f6b075","chunk-b4785cd6":"b5d2cea1","chunk-2363649f":"b960f81e","chunk-2d0af505":"0f339a70","chunk-51629167":"25ba0802","chunk-5913f34d":"274cb5a6","chunk-cfb725f0":"43062734","chunk-260d50d6":"d79c49a8","chunk-196c03cc":"a2e1c1cd","chunk-2216ae17":"27a2ca61","chunk-2c1a3390":"ef5f2fd3","chunk-4345fed8":"a0367ebe","chunk-9a26881c":"f6b59808","locale-en-US-json":"be3575e7","locale-ru-RU-json":"3ebd2be1"}[chunkId] + ".js"
 	}

 	// object to store loaded and loading wasm modules
 	var installedWasmModules = {};

 	function promiseResolve() { return Promise.resolve(); }

 	var wasmImportObjects = {
 		"629b": function() {
 			return {
 				"./cardano_serialization_lib_bg.js": {
 					"__wbindgen_object_drop_ref": function(p0i32) {
 						return installedModules["ea7e"].exports["ie"](p0i32);
 					},
 					"__wbindgen_string_new": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["ke"](p0i32,p1i32);
 					},
 					"__wbindgen_error_new": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["Zd"](p0i32,p1i32);
 					},
 					"__wbindgen_string_get": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["je"](p0i32,p1i32);
 					},
 					"__wbindgen_number_new": function(p0f64) {
 						return installedModules["ea7e"].exports["ge"](p0f64);
 					},
 					"__wbindgen_object_clone_ref": function(p0i32) {
 						return installedModules["ea7e"].exports["he"](p0i32);
 					},
 					"__wbindgen_is_object": function(p0i32) {
 						return installedModules["ea7e"].exports["be"](p0i32);
 					},
 					"__wbg_set_20cbc34131e76824": function(p0i32,p1i32,p2i32) {
 						return installedModules["ea7e"].exports["Qd"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_String_91fba7ded13ba54c": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["nd"](p0i32,p1i32);
 					},
 					"__wbg_randomFillSync_dc1e9a60c158336d": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["Kd"](p0i32,p1i32);
 					},
 					"__wbg_getRandomValues_37fa2ca9e4e07fab": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["vd"](p0i32,p1i32);
 					},
 					"__wbg_crypto_c48a774b022d20ac": function(p0i32) {
 						return installedModules["ea7e"].exports["sd"](p0i32);
 					},
 					"__wbg_process_298734cf255a885d": function(p0i32) {
 						return installedModules["ea7e"].exports["Jd"](p0i32);
 					},
 					"__wbg_versions_e2e78e134e3e5d01": function(p0i32) {
 						return installedModules["ea7e"].exports["Wd"](p0i32);
 					},
 					"__wbg_node_1cd7a5d853dbea79": function(p0i32) {
 						return installedModules["ea7e"].exports["Id"](p0i32);
 					},
 					"__wbindgen_is_string": function(p0i32) {
 						return installedModules["ea7e"].exports["ce"](p0i32);
 					},
 					"__wbg_require_8f08ceecec0f4fee": function() {
 						return installedModules["ea7e"].exports["Nd"]();
 					},
 					"__wbg_msCrypto_bcb970640f50a1e8": function(p0i32) {
 						return installedModules["ea7e"].exports["zd"](p0i32);
 					},
 					"__wbg_new_1d9a920c6bfc44a8": function() {
 						return installedModules["ea7e"].exports["Bd"]();
 					},
 					"__wbindgen_is_function": function(p0i32) {
 						return installedModules["ea7e"].exports["ae"](p0i32);
 					},
 					"__wbg_newnoargs_b5b063fc6c2f0376": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["Fd"](p0i32,p1i32);
 					},
 					"__wbg_new_268f7b7dd3430798": function() {
 						return installedModules["ea7e"].exports["Cd"]();
 					},
 					"__wbg_call_97ae9d8645dc388b": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["qd"](p0i32,p1i32);
 					},
 					"__wbg_new_0b9bfdd97583284e": function() {
 						return installedModules["ea7e"].exports["Ad"]();
 					},
 					"__wbg_self_6d479506f72c6a71": function() {
 						return installedModules["ea7e"].exports["Od"]();
 					},
 					"__wbg_window_f2557cc78490aceb": function() {
 						return installedModules["ea7e"].exports["Xd"]();
 					},
 					"__wbg_globalThis_7f206bda628d5286": function() {
 						return installedModules["ea7e"].exports["xd"]();
 					},
 					"__wbg_global_ba75c50d1cf384f4": function() {
 						return installedModules["ea7e"].exports["yd"]();
 					},
 					"__wbindgen_is_undefined": function(p0i32) {
 						return installedModules["ea7e"].exports["de"](p0i32);
 					},
 					"__wbg_set_a68214f35c417fa9": function(p0i32,p1i32,p2i32) {
 						return installedModules["ea7e"].exports["Td"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_call_168da88779e35f61": function(p0i32,p1i32,p2i32) {
 						return installedModules["ea7e"].exports["pd"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_set_933729cf5b66ac11": function(p0i32,p1i32,p2i32) {
 						return installedModules["ea7e"].exports["Sd"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_buffer_3f3d764d4747d564": function(p0i32) {
 						return installedModules["ea7e"].exports["od"](p0i32);
 					},
 					"__wbg_newwithbyteoffsetandlength_d9aa266703cb98be": function(p0i32,p1i32,p2i32) {
 						return installedModules["ea7e"].exports["Gd"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_new_8c3f0052272a457a": function(p0i32) {
 						return installedModules["ea7e"].exports["Dd"](p0i32);
 					},
 					"__wbg_set_83db9690f9353e79": function(p0i32,p1i32,p2i32) {
 						return installedModules["ea7e"].exports["Rd"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_newwithlength_f5933855e4f48a19": function(p0i32) {
 						return installedModules["ea7e"].exports["Hd"](p0i32);
 					},
 					"__wbg_subarray_58ad4efbb5bcb886": function(p0i32,p1i32,p2i32) {
 						return installedModules["ea7e"].exports["Vd"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_new_d87f272aec784ec0": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["Ed"](p0i32,p1i32);
 					},
 					"__wbg_call_eae29933372a39be": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["rd"](p0i32,p1i32);
 					},
 					"__wbindgen_jsval_eq": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["ee"](p0i32,p1i32);
 					},
 					"__wbg_self_e0b3266d2d9eba1a": function(p0i32) {
 						return installedModules["ea7e"].exports["Pd"](p0i32);
 					},
 					"__wbg_crypto_e95a6e54c5c2e37f": function(p0i32) {
 						return installedModules["ea7e"].exports["td"](p0i32);
 					},
 					"__wbg_getRandomValues_dc67302a7bd1aec5": function(p0i32) {
 						return installedModules["ea7e"].exports["wd"](p0i32);
 					},
 					"__wbg_require_0993fe224bf8e202": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["Md"](p0i32,p1i32);
 					},
 					"__wbg_randomFillSync_dd2297de5917c74e": function(p0i32,p1i32,p2i32) {
 						return installedModules["ea7e"].exports["Ld"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_getRandomValues_02639197c8166a96": function(p0i32,p1i32,p2i32) {
 						return installedModules["ea7e"].exports["ud"](p0i32,p1i32,p2i32);
 					},
 					"__wbindgen_debug_string": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["Yd"](p0i32,p1i32);
 					},
 					"__wbindgen_throw": function(p0i32,p1i32) {
 						return installedModules["ea7e"].exports["le"](p0i32,p1i32);
 					},
 					"__wbindgen_memory": function() {
 						return installedModules["ea7e"].exports["fe"]();
 					}
 				}
 			};
 		},
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-2363649f":1,"chunk-51629167":1,"chunk-5913f34d":1,"chunk-cfb725f0":1,"chunk-260d50d6":1,"chunk-196c03cc":1,"chunk-2216ae17":1,"chunk-2c1a3390":1,"chunk-4345fed8":1,"chunk-9a26881c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"locale-en-US-json":"locale-en-US-json","locale-ru-RU-json":"locale-ru-RU-json"}[chunkId]||chunkId) + "." + {"chunk-2d0d7e47":"31d6cfe0","chunk-6ace265c":"31d6cfe0","chunk-b4785cd6":"31d6cfe0","chunk-2363649f":"05b6e97f","chunk-2d0af505":"31d6cfe0","chunk-51629167":"429f0dae","chunk-5913f34d":"9d699d6d","chunk-cfb725f0":"22eb36be","chunk-260d50d6":"a19072f7","chunk-196c03cc":"8f523b87","chunk-2216ae17":"40e04bc5","chunk-2c1a3390":"edf516c4","chunk-4345fed8":"266b394f","chunk-9a26881c":"ae68b7e5","locale-en-US-json":"31d6cfe0","locale-ru-RU-json":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// Fetch + compile chunk loading for webassembly

 		var wasmModules = {"chunk-6ace265c":["629b"]}[chunkId] || [];

 		wasmModules.forEach(function(wasmModuleId) {
 			var installedWasmModuleData = installedWasmModules[wasmModuleId];

 			// a Promise means "currently loading" or "already loaded".
 			if(installedWasmModuleData)
 				promises.push(installedWasmModuleData);
 			else {
 				var importObject = wasmImportObjects[wasmModuleId]();
 				var req = fetch(__webpack_require__.p + "" + {"629b":"774417ace5c66fdaeb6d"}[wasmModuleId] + ".module.wasm");
 				var promise;
 				if(importObject instanceof Promise && typeof WebAssembly.compileStreaming === 'function') {
 					promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
 						return WebAssembly.instantiate(items[0], items[1]);
 					});
 				} else if(typeof WebAssembly.instantiateStreaming === 'function') {
 					promise = WebAssembly.instantiateStreaming(req, importObject);
 				} else {
 					var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
 					promise = bytesPromise.then(function(bytes) {
 						return WebAssembly.instantiate(bytes, importObject);
 					});
 				}
 				promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
 					return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
 				}));
 			}
 		});
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// object with all WebAssembly.instance exports
 	__webpack_require__.w = {};

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
